export interface EmployeerDetail {
  payroll_Company: string;
  payroll_Company_id: number;
  us_Company: string;
  company_Id: number;
  date_Of_Joining: string;
  business_Process: string;
  business_Process_id: number;
  esic_Member: boolean;
  esic_Number: string;
  uan_Number: string;
  is_Experience: boolean;
  experience_In_Month: number;
  currentExperienceInMonths?: number;
  previousExperienceInMonths?: number;
  organization_Name: string;
  gross_Salary: number;
  basic_salary: number;
  hra: number;
  conveyance: number;
  salary_Per_Month: number;
  gross_Salary_Per_Month?: number;
  gross_Salary_per_anum?: number;
  pf: number;
  esi_Health_Insurance: number;
  total_Deduction: number;
  net_Salary?: number;
  manager: string;
  managerId: number;
  teamLead: string;
  teamLeadId: number;
  branchHead?: string;
  branchHeadId: number;
  branch_Id: number;
  branch: string;
  department_Id: number;
  department: string;
  shift: number;
  shift_Name: string;
  mealAllowance: boolean;
  transportAllowance: boolean;
  healthInsurance: boolean;
  basic_Salary_for_pf?: number;
  employeePF?: number;
  employerPF?: number;
  esicEmployee?: number;
  esicEmployer?: number;
  monthlyCTC?: number;
  annualCTC?: number;
  netTakeHomeSalary?: number;
  esicApplicable?: boolean;
  companyBenefitCost?: number;
  includePf?: boolean
  designation_Id?: number,
  last_Increment_Date?: string;
  designation?: string
  employement_Type: "EMPLOYEE" | "INTERN";
  intern_Payment_Type?: "PAID" | "UNPAID" | "";
  last_Working_Date?: string
  status?: number,
  includeEsic?: boolean
  enableElCl?: boolean;
  managerCode?: string;
  teamLeadCode?: string;
  branchHeadCode?: string;
}
export interface EmployementDetail {
  payroll_Company: string;
  payroll_Company_Id: number;
  us_Company?: string;
  us_Company_Id: number;
  branch_Id: number;
  branch: string;
  department_Id: number;
  department: string;
  shift: number;
  shift_Name: string;
  date_Of_Joining: string;
  business_Process: string;
  business_Process_Id: number;
  emp_Id: string;
  designation_Id?: number,
  last_Increment_Date?: string;
  last_Working_Date?: string;
  change_Effective_Date?: string;
}
export interface BenefitsAndIDNumber {
  esic_Member: boolean;
  esic_Number: number;
  uan_Number?: string;
  emp_Id: string;
}
type EmployerDetailKey = keyof EmployeerDetail;
type EmployeBenefitKey = keyof EmployeerDetail;

interface EmployerDetailHeader {
  key: EmployerDetailKey;
  label: string;
  formate?: any;
}
interface BenefitAndIdNumberHeader {
  key: EmployeBenefitKey;
  label: string;
  modifier?: any;
}

const formatExperience = (value?: number) => {
  if (value == null) return "";

  const years = Math.floor(value / 12);
  const months = value % 12;

  if (years > 0 && months > 0)
    return `${years} Year${years > 1 ? "s" : ""} ${months} Month${months > 1 ? "s" : ""}`;

  if (years > 0)
    return `${years} Year${years > 1 ? "s" : ""}`;

  return `${months} Month${months !== 1 ? "s" : ""}`;
};

export const EmployerDetailHeaders: EmployerDetailHeader[] = [
  { key: "payroll_Company", label: "Payroll Company" },
  { key: "us_Company", label: "Company" },
  { key: "branch", label: "Branch" },
  { key: "department", label: "Department" },
  { key: "shift_Name", label: "Shift" },
  { key: "business_Process", label: "Business Process" },
  { key: "date_Of_Joining", label: "Date of Joining" },
  { key: "last_Increment_Date", label: "Last Increment Date" },
  { key: "designation", label: "Designation" },
];
export const BenefitsAndIDNumberHeaders: BenefitAndIdNumberHeader[] = [
  { key: "esic_Member", label: "ESIC Member", modifier: (data: any) => (data ? "Yes" : "No"), },
  { key: "esic_Number", label: "ESIC Number" },
  { key: "uan_Number", label: "UAN Number" },
];
export const Experience: EmployerDetailHeader[] = [
  { key: "currentExperienceInMonths", label: "Experience with Us", formate: formatExperience, },
  { key: "previousExperienceInMonths", label: "Previous Experience", formate: formatExperience, },
  { key: "experience_In_Month", label: "Total Experience", formate: formatExperience, },
  { key: "organization_Name", label: "Last Organization Name" },
];
export const Salary: EmployerDetailHeader[] = [
  { key: "employement_Type", label: "Employement Type", },
  { key: "intern_Payment_Type", label: "Intern Payment Type", },
  { key: "enableElCl", label: "EL/CL Enabled", },
  { key: "gross_Salary_Per_Month", label: "Gross Salary (Per Month)", },
  { key: "gross_Salary_per_anum", label: "Gross Salary (Per Annum)", },
  { key: "basic_salary", label: "Basic Salary", },
  { key: "hra", label: "HRA", },
  { key: "conveyance", label: "Conveyance", },
  { key: "employerPF", label: "Employer PF", },
  { key: "esicEmployer", label: "Employer ESI", },
  { key: "companyBenefitCost", label: "Company Benfit Cost", },
  { key: "monthlyCTC", label: "Monthly CTC", },
  { key: "annualCTC", label: "Annual CTC", },
];
export const Deduction: EmployerDetailHeader[] = [
  { key: "employeePF", label: "Employee PF", },
  { key: "esicEmployee", label: "Employee ESI", },
  { key: "total_Deduction", label: "Total Deduction", },
  { key: "netTakeHomeSalary", label: "Net Salary(Gross -(Employee PF + Employee ESI))", },
];

export const HeirarchyDetal: EmployerDetailHeader[] = [
  { key: "manager", label: "Manager" },
  { key: "teamLead", label: "Team Lead" },
  { label: "Branch Head", key: "branchHead", },
];